import useSWR, { SWRConfiguration } from 'swr';

import { GetAllAsync } from '../../services/api';
import { KendoGridResult } from '../../types/KendoGridResult';
import { CountryResponse } from '../../types/responses/country-response';

const CountryEndpoint = `countries`;
const LanguageEndpoint = `countries/languages`;

export const useGetCountries = (options?: SWRConfiguration) => {
  const { data, error, isLoading } = useSWR<KendoGridResult<CountryResponse>>(
    `${CountryEndpoint}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    countries: data?.data,
    isLoading,
    isError: error
  };
};

export const useGetLanguages = (options?: SWRConfiguration) => {
  const { data, error, isLoading } = useSWR<KendoGridResult<CountryResponse>>(
    `${LanguageEndpoint}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    languages: data?.data,
    isLoading,
    isError: error
  };
};
